import { Navigate, Outlet, useLocation } from 'react-router';
import CustomizePageLayout from './customize.page-layout.jsx';
import { getTypeSlug } from '@util/common.js';
import { overlays } from '@data/overlays.jsx';
import { categories } from '@data/categories.js';
import { Suspense } from 'preact/compat';

export default function OverlayPageLayout() {
  const location = useLocation();
  const { slug, type } = getTypeSlug(location.pathname);

  const overlayInfo = overlays[slug];

  if (overlayInfo === undefined)
    return <Navigate to={`/${type}`} replace={true} />;

  const { name, pageName } = categories.find(
    (category) => category.type === type
  );

  const parents = [{ title: pageName || name, href: `/${type}` }];

  return (
    <CustomizePageLayout {...overlayInfo} parents={parents}>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </CustomizePageLayout>
  );
}
